import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { ContextMenuCursorIcon } from './icons';

import './style.scss';

type EmailItem = {
  sender: string;
  subject: string;
  preview: string;
  time: string;
  active?: boolean;
};

const EMAIL_ITEMS: EmailItem[] = [
  {
    sender: 'Client A - Alpha Industries',
    subject: '[CLIENT REQUEST] - Tradable prices @',
    preview: '2:55 PM',
    time: '10:12',
    active: true,
  },
  {
    sender: 'Client B - Beta Collection LTD',
    subject: 'FW BetaC Autocallable Barrier reverse convertible',
    preview: 'Hi there, Follow up about the quote SG Autocallable Barrier reverse convertible',
    time: '09:56',
  },
  {
    sender: 'Client C - Citron Entreprise',
    subject: 'TR to Trade INVERSE RC Autocall on Pheonix',
    preview: 'Hell, About what we discussed earlier, I would like to trade the INVERSE RC Autocall on Pheonix',
    time: '09:56',
  },
];

export function CopyCard({ className, ...props }: Omit<ComponentProps<'div'>, 'children'>) {
  return (
    <Card
      className={classNames('quick-start-card border border-opacity-40 bg-transparent overflow-hidden', className)}
      {...props}
    >
      <Card.Header className="p-3">
        <Card.Title as="h5">
          <FormattedMessage
            id="smartQuote.quickStart.card1.title"
            defaultMessage="Copy & paste email from your Outlook"
          />
        </Card.Title>
      </Card.Header>
      <Card.Body className="p-0 ps-4">
        <ul className="list-group bg-secondary bg-opacity-05">
          {EMAIL_ITEMS.map(({ sender, subject, preview, time, active }) => (
            <li
              key={sender}
              className={classNames(
                'flex-x gap-2 list-group-item align-items-center fs-12 border-bottom border-opacity-40',
                { 'email-active': active },
              )}
            >
              <div className="flex-y flex-grow-1 text-truncate">
                <span className="fs-16 text-truncate">{sender}</span>
                <span className="text-truncate">{subject}</span>
                <span className="text-secondary text-truncate">{preview}</span>
              </div>
              <span>{time}</span>
              {active && <ContextMenuCursorIcon />}
            </li>
          ))}
        </ul>
      </Card.Body>
    </Card>
  );
}
